<div class="cpcontent">
    <h2>Googel API</h2>
    This is the basic page setup to include a google map. No other functionality is added.<br>
    Api Key: {{env.googlemapapikey}}
    <br>

    <b>Note:</b> The Vielchild definition needs to have static: true inserted
    <br><br>
    <div id="map" #map style="width:100%;height:400px"></div>
    How To:
    <ul>
        <li>npm install --save @types/googlemaps</li>
        <li>Add {{' <script src="http://maps.googleapis.com/maps/api/js?key=API-KEY"></script> '}} in index.html</li>
        <li>Add <pre>
            div #map style="width:100%;height:400px">/div>
        </pre> in this html page</li>
        <li>declare module 'googlemaps'; in index.d.ts</li>
        <li>add @ViewChild('map',<b>{{'{'}}static: true{{'}'}}</b>) mapElement: any;
            map: google.maps.Map; to ts file</li>
        <li><pre>
            ngOnInit(): void {{'{'}}
            const mapProperties = {{'{'}}
                 center: new google.maps.LatLng(35.2271, -80.8431),
                 zoom: 15,
                 mapTypeId: google.maps.MapTypeId.ROADMAP
                 {{'}'}};
            this.map = new google.maps.Map(this.mapElement.nativeElement,    mapProperties);
            {{'}'}}</pre></li>
        <li><b>ng serve </b> </li>

    </ul>
</div>
